var __defProp = Object.defineProperty;
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var _renderedQuery, _controller, _activeFetch, _emptyStateLoaded, _handleModalClick, _handleKeyboardShortcut, _handleDialogClose, _handleDialogOpen, _PredictiveSearchComponent_instances, loadEmptyState_fn, allResultsItems_get, _isKeyboardNavigation, currentIndex_get, currentIndex_set, currentItem_get, resetScrollPositions_fn, getSearchResults_fn, getRecentlyViewedProductsMarkup_fn, hideResetButton_fn, showResetButton_fn, createAbortController_fn, _resetSearch;
import { Component } from "@theme/component";
import { debounce, onAnimationEnd, prefersReducedMotion, requestIdleCallback } from "@theme/utilities";
import { sectionRenderer } from "@theme/section-renderer";
import { morph } from "@theme/morph";
import { RecentlyViewed } from "@theme/recently-viewed-products";
import { DialogCloseEvent, DialogOpenEvent, DialogComponent } from "@theme/dialog";
import { SearchUpdateEvent } from "@shopify/events";
class PredictiveSearchComponent extends Component {
  constructor() {
    super(...arguments);
    __privateAdd(this, _PredictiveSearchComponent_instances);
    __publicField(this, "requiredRefs", ["searchInput", "predictiveSearchResults", "resetButton"]);
    __privateAdd(this, _controller, new AbortController());
    __privateAdd(this, _activeFetch, null);
    __privateAdd(this, _emptyStateLoaded, false);
    __privateAdd(this, _renderedQuery, "");
    __privateAdd(this, _handleModalClick, (event) => {
      const target = (
        /** @type {HTMLElement} */
        event.target
      );
      const isInteractiveElement = target instanceof HTMLButtonElement || target instanceof HTMLAnchorElement || target instanceof HTMLInputElement || target.closest("button") || target.closest("a") || target.closest("input");
      if (!isInteractiveElement && this.refs.searchInput) {
        this.refs.searchInput.focus();
      }
    });
    __privateAdd(this, _handleKeyboardShortcut, (event) => {
      var _a;
      if (event.metaKey && event.key === "k") {
        (_a = this.dialog) == null ? void 0 : _a.toggleDialog();
      }
    });
    __privateAdd(this, _handleDialogClose, () => {
      __privateGet(this, _resetSearch).call(this);
    });
    __privateAdd(this, _handleDialogOpen, () => {
      if (!__privateGet(this, _emptyStateLoaded) && RecentlyViewed.getProducts().length > 0) {
        __privateMethod(this, _PredictiveSearchComponent_instances, loadEmptyState_fn).call(this);
      }
    });
    __privateAdd(this, _isKeyboardNavigation, false);
    __publicField(this, "onSearchKeyDown", (event) => {
      var _a, _b, _c;
      if (event.target !== this.refs.searchInput || event.defaultPrevented || event.isComposing) return;
      if (event.key === "Escape") {
        __privateGet(this, _resetSearch).call(this);
        return;
      }
      if (this.refs.predictiveSearchResults.hidden || this.refs.searchInput.value.trim() !== __privateGet(this, _renderedQuery)) return;
      if (!((_a = __privateGet(this, _PredictiveSearchComponent_instances, allResultsItems_get)) == null ? void 0 : _a.length) || event.key === "ArrowLeft" || event.key === "ArrowRight") {
        return;
      }
      const currentIndex = __privateGet(this, _PredictiveSearchComponent_instances, currentIndex_get);
      const totalItems = __privateGet(this, _PredictiveSearchComponent_instances, allResultsItems_get).length;
      switch (event.key) {
        case "ArrowDown":
          __privateSet(this, _isKeyboardNavigation, true);
          event.preventDefault();
          __privateSet(this, _PredictiveSearchComponent_instances, currentIndex < totalItems - 1 ? currentIndex + 1 : 0, currentIndex_set);
          break;
        case "ArrowUp":
          __privateSet(this, _isKeyboardNavigation, true);
          event.preventDefault();
          __privateSet(this, _PredictiveSearchComponent_instances, currentIndex > 0 ? currentIndex - 1 : totalItems - 1, currentIndex_set);
          break;
        case "Enter": {
          const singleResultContainer = this.refs.predictiveSearchResults.querySelector("[data-single-result-url]");
          if (singleResultContainer instanceof HTMLElement && singleResultContainer.dataset.singleResultUrl) {
            event.preventDefault();
            window.location.href = singleResultContainer.dataset.singleResultUrl;
            return;
          }
          if (__privateGet(this, _PredictiveSearchComponent_instances, currentIndex_get) >= 0) {
            event.preventDefault();
            (_c = (_b = __privateGet(this, _PredictiveSearchComponent_instances, currentItem_get)) == null ? void 0 : _b.querySelector("a")) == null ? void 0 : _c.click();
          } else {
            event.preventDefault();
            const searchUrl = new URL(Theme.routes.search_url, location.origin);
            searchUrl.searchParams.set("q", this.refs.searchInput.value);
            window.location.href = searchUrl.toString();
          }
          break;
        }
      }
    });
    __publicField(this, "resetSearch", debounce((keepFocus = true) => {
      if (keepFocus === false && this.refs.searchInput.value.trim()) return;
      if (keepFocus) {
        this.refs.searchInput.focus();
      }
      __privateGet(this, _resetSearch).call(this);
    }, 100));
    __publicField(this, "search", debounce((event) => {
      if (event.isComposing) return;
      this.resetSearch.cancel();
      const searchTerm = this.refs.searchInput.value.trim();
      __privateSet(this, _PredictiveSearchComponent_instances, -1, currentIndex_set);
      if (!searchTerm.length) {
        __privateGet(this, _resetSearch).call(this);
        return;
      }
      __privateMethod(this, _PredictiveSearchComponent_instances, showResetButton_fn).call(this);
      __privateMethod(this, _PredictiveSearchComponent_instances, getSearchResults_fn).call(this, searchTerm);
    }, 200));
    __privateAdd(this, _resetSearch, async () => {
      const { predictiveSearchResults, searchInput } = this.refs;
      const emptySectionId = "predictive-search-empty";
      __privateSet(this, _PredictiveSearchComponent_instances, -1, currentIndex_set);
      searchInput.value = "";
      __privateMethod(this, _PredictiveSearchComponent_instances, hideResetButton_fn).call(this);
      const abortController = __privateMethod(this, _PredictiveSearchComponent_instances, createAbortController_fn).call(this);
      const url = new URL(window.location.href);
      url.searchParams.delete("page");
      this.search.cancel();
      __privateSet(this, _renderedQuery, "");
      searchInput.setAttribute("aria-expanded", "false");
      searchInput.removeAttribute("aria-activedescendant");
      predictiveSearchResults.hidden = true;
      predictiveSearchResults.setAttribute("aria-busy", "true");
      if (this.refs.searchError) this.refs.searchError.hidden = true;
      try {
        const emptySectionMarkup = await sectionRenderer.getSectionHTML(emptySectionId, false, url, abortController.signal);
        const parsedEmptySectionMarkup = new DOMParser().parseFromString(emptySectionMarkup, "text/html").querySelector(".predictive-search-empty-section");
        if (!parsedEmptySectionMarkup) throw new Error("No empty section markup found");
        const viewedProducts = RecentlyViewed.getProducts();
        if (viewedProducts.length > 0) {
          try {
            const recentlyViewedMarkup = await __privateMethod(this, _PredictiveSearchComponent_instances, getRecentlyViewedProductsMarkup_fn).call(this, abortController.signal);
            if (recentlyViewedMarkup) {
              const parsedRecentlyViewedMarkup = new DOMParser().parseFromString(recentlyViewedMarkup, "text/html");
              const recentlyViewedProductsHtml = parsedRecentlyViewedMarkup.getElementById("predictive-search-products");
              const collectionElement = parsedEmptySectionMarkup.querySelector("#predictive-search-products");
              if (recentlyViewedProductsHtml && collectionElement) {
                for (const child of recentlyViewedProductsHtml.children) {
                  if (child instanceof HTMLElement) child.setAttribute("ref", "recentlyViewedWrapper");
                }
                collectionElement.prepend(...recentlyViewedProductsHtml.children);
              }
            }
          } catch (error) {
            if (abortController.signal.aborted) return;
          }
        }
        if (abortController.signal.aborted || searchInput.value.trim()) return;
        morph(predictiveSearchResults, parsedEmptySectionMarkup);
        __privateMethod(this, _PredictiveSearchComponent_instances, resetScrollPositions_fn).call(this);
        predictiveSearchResults.hidden = false;
        __privateSet(this, _emptyStateLoaded, true);
      } catch (error) {
        if (!abortController.signal.aborted && !searchInput.value.trim() && this.refs.searchError) this.refs.searchError.hidden = false;
      } finally {
        if (__privateGet(this, _activeFetch) === abortController) {
          __privateSet(this, _activeFetch, null);
          predictiveSearchResults.setAttribute("aria-busy", "false");
        }
      }
    });
  }
  /**
   * Get the dialog component.
   * @returns {DialogComponent | null} The dialog component.
   */
  get dialog() {
    return this.closest("dialog-component");
  }
  connectedCallback() {
    super.connectedCallback();
    const { dialog } = this;
    if (__privateGet(this, _controller).signal.aborted) __privateSet(this, _controller, new AbortController());
    const { signal } = __privateGet(this, _controller);
    if (this.refs.searchInput.value.length > 0) {
      __privateMethod(this, _PredictiveSearchComponent_instances, showResetButton_fn).call(this);
    }
    if (dialog) {
      document.addEventListener("keydown", __privateGet(this, _handleKeyboardShortcut), { signal });
      dialog.addEventListener(DialogCloseEvent.eventName, __privateGet(this, _handleDialogClose), { signal });
      dialog.addEventListener(DialogOpenEvent.eventName, __privateGet(this, _handleDialogOpen), { signal });
      this.addEventListener("click", __privateGet(this, _handleModalClick), { signal });
    }
    if (RecentlyViewed.getProducts().length > 0) {
      requestIdleCallback(() => {
        __privateMethod(this, _PredictiveSearchComponent_instances, loadEmptyState_fn).call(this);
      });
    }
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    __privateGet(this, _controller).abort();
    this.search.cancel();
    this.resetSearch.cancel();
    const active = __privateGet(this, _activeFetch);
    if (active) active.abort();
  }
  /**
   * Clears the recently viewed products.
   * @param {Event} event - The event.
   */
  clearRecentlyViewedProducts(event) {
    event.stopPropagation();
    RecentlyViewed.clearProducts();
    const { recentlyViewedItems, recentlyViewedTitle, recentlyViewedWrapper } = this.refs;
    const allRecentlyViewedElements = [...recentlyViewedItems || [], ...recentlyViewedTitle || []];
    if (allRecentlyViewedElements.length === 0) {
      return;
    }
    if (recentlyViewedWrapper) {
      recentlyViewedWrapper.classList.add("removing");
      onAnimationEnd(recentlyViewedWrapper, () => {
        recentlyViewedWrapper.remove();
      });
    }
  }
}
_renderedQuery = /* @__PURE__ */ new WeakMap();
_controller = /* @__PURE__ */ new WeakMap();
_activeFetch = /* @__PURE__ */ new WeakMap();
_emptyStateLoaded = /* @__PURE__ */ new WeakMap();
_handleModalClick = /* @__PURE__ */ new WeakMap();
_handleKeyboardShortcut = /* @__PURE__ */ new WeakMap();
_handleDialogClose = /* @__PURE__ */ new WeakMap();
_handleDialogOpen = /* @__PURE__ */ new WeakMap();
_PredictiveSearchComponent_instances = /* @__PURE__ */ new WeakSet();
loadEmptyState_fn = function() {
  if (!this.isConnected || this.refs.searchInput.value.trim() || __privateGet(this, _emptyStateLoaded)) return;
  this.resetSearch(false);
};
allResultsItems_get = function() {
  const containers = Array.from(
    this.querySelectorAll(
      ".predictive-search-results__wrapper-queries, .predictive-search-results__wrapper-products, .predictive-search-results__list"
    )
  );
  const allItems = [];
  containers.forEach((container) => {
    const selector = container.classList.contains("predictive-search-results__wrapper-products")
      ? ".predictive-search-results__card"
      : '[ref="resultsItems[]"], .predictive-search-results__card';
    Array.from(container.querySelectorAll(selector)).forEach((item) => {
      if (item instanceof HTMLElement) allItems.push(item);
    });
  });
  return (
    /** @type {HTMLElement[]} */
    allItems
  );
};
_isKeyboardNavigation = /* @__PURE__ */ new WeakMap();
currentIndex_get = function() {
  var _a, _b;
  return (_b = (_a = __privateGet(this, _PredictiveSearchComponent_instances, allResultsItems_get)) == null ? void 0 : _a.findIndex((item) => item.getAttribute("aria-selected") === "true")) != null ? _b : -1;
};
currentIndex_set = function(index) {
  var _a;
  if (!((_a = __privateGet(this, _PredictiveSearchComponent_instances, allResultsItems_get)) == null ? void 0 : _a.length)) return;
  let activeItem = null;
  __privateGet(this, _PredictiveSearchComponent_instances, allResultsItems_get).forEach((item) => {
    item.classList.remove("keyboard-focus");
  });
  for (const [itemIndex, item] of __privateGet(this, _PredictiveSearchComponent_instances, allResultsItems_get).entries()) {
    if (itemIndex === index) {
      item.setAttribute("aria-selected", "true");
      if (__privateGet(this, _isKeyboardNavigation)) {
        item.classList.add("keyboard-focus");
      }
      activeItem = item;
    } else {
      item.removeAttribute("aria-selected");
    }
  }
  activeItem == null ? void 0 : activeItem.scrollIntoView({ behavior: prefersReducedMotion() ? "instant" : "smooth", block: "nearest" });
  this.refs.searchInput.focus();
};
currentItem_get = function() {
  var _a;
  return (_a = __privateGet(this, _PredictiveSearchComponent_instances, allResultsItems_get)) == null ? void 0 : _a[__privateGet(this, _PredictiveSearchComponent_instances, currentIndex_get)];
};
resetScrollPositions_fn = function() {
  requestAnimationFrame(() => {
    const targets = [this.refs.predictiveSearchResults.querySelector(".predictive-search-results__inner"), this.querySelector(".predictive-search-form__content")];
    for (const target of targets) {
      if (!target) continue;
      if (typeof target.scrollTo === "function") target.scrollTo(0, 0);
      else {
        target.scrollTop = 0;
        target.scrollLeft = 0;
      }
    }
  });
};
getSearchResults_fn = async function(searchTerm) {
  if (!this.dataset.sectionId) return;
  const url = new URL(Theme.routes.predictive_search_url, location.origin);
  url.searchParams.set("q", searchTerm);
  url.searchParams.set("resources[limit_scope]", "each");
  const { predictiveSearchResults } = this.refs;
  const abortController = __privateMethod(this, _PredictiveSearchComponent_instances, createAbortController_fn).call(this);
  const deferredPromise = SearchUpdateEvent.createPromise();
  this.dispatchEvent(
    new SearchUpdateEvent({
      search: {
        query: searchTerm
      },
      promise: deferredPromise.promise
    })
  );
  predictiveSearchResults.hidden = true;
  predictiveSearchResults.setAttribute("aria-busy", "true");
  this.refs.searchInput.setAttribute("aria-expanded", "false");
  this.refs.searchInput.removeAttribute("aria-activedescendant");
  if (this.refs.searchError) this.refs.searchError.hidden = true;
  try {
    const resultsMarkup = await sectionRenderer.getSectionHTML(this.dataset.sectionId, false, url, abortController.signal);
    if (abortController.signal.aborted || this.refs.searchInput.value.trim() !== searchTerm) {
      const error = new Error("Search superseded");
      error.name = "AbortError";
      throw error;
    }
    if (!resultsMarkup) throw new Error("No search results markup");
    morph(predictiveSearchResults, resultsMarkup);
    predictiveSearchResults.hidden = false;
    __privateSet(this, _renderedQuery, searchTerm);
    this.refs.searchInput.setAttribute("aria-expanded", "true");
    __privateMethod(this, _PredictiveSearchComponent_instances, resetScrollPositions_fn).call(this);
    const resultCount = predictiveSearchResults.querySelectorAll('[ref="resultsItems[]"]').length;
    deferredPromise.resolve({ totalCount: resultCount });
  } catch (error) {
    deferredPromise.reject(error);
    if (!abortController.signal.aborted && this.refs.searchInput.value.trim() === searchTerm && this.refs.searchError) this.refs.searchError.hidden = false;
  } finally {
    if (__privateGet(this, _activeFetch) === abortController) {
      __privateSet(this, _activeFetch, null);
      predictiveSearchResults.setAttribute("aria-busy", "false");
    }
  }
};
getRecentlyViewedProductsMarkup_fn = async function(signal) {
  if (!this.dataset.sectionId) return null;
  const viewedProducts = RecentlyViewed.getProducts();
  if (viewedProducts.length === 0) return null;
  const url = new URL(Theme.routes.search_url, location.origin);
  url.searchParams.set("q", viewedProducts.map(
    /** @param {string} id */
    (id) => "id:".concat(id)
  ).join(" OR "));
  url.searchParams.set("resources[type]", "product");
  return sectionRenderer.getSectionHTML(this.dataset.sectionId, false, url, signal);
};
hideResetButton_fn = function() {
  const { resetButton } = this.refs;
  resetButton.hidden = true;
};
showResetButton_fn = function() {
  const { resetButton } = this.refs;
  resetButton.hidden = false;
};
createAbortController_fn = function() {
  const abortController = new AbortController();
  if (__privateGet(this, _activeFetch)) {
    __privateGet(this, _activeFetch).abort();
  }
  __privateSet(this, _activeFetch, abortController);
  return abortController;
};
_resetSearch = /* @__PURE__ */ new WeakMap();
if (!customElements.get("predictive-search-component")) {
  customElements.define("predictive-search-component", PredictiveSearchComponent);
}
